import { useParams } from "react-router-dom";
import { JobIframe as JobIframeComponent } from "../components/job-iframe/JobIframe";
import PageNotFound from "./PageNotFound";

const JobIframe = () => {
  const { id } = useParams();

  if (!id) {
    return <PageNotFound />;
  }

  return <JobIframeComponent id={id} />;
};

export default JobIframe;
